import { UserVisibleMcpServer } from '@/types/mcp'

function normalizeServerLabel(value: string | undefined): string {
  return (value || '').trim().toLocaleLowerCase()
}

export function compareUserVisibleMcpServers(left: UserVisibleMcpServer, right: UserVisibleMcpServer): number {
  const displayComparison = normalizeServerLabel(left.displayName).localeCompare(normalizeServerLabel(right.displayName))
  if (displayComparison !== 0) {
    return displayComparison
  }

  return normalizeServerLabel(left.name).localeCompare(normalizeServerLabel(right.name))
}

export function matchesUserVisibleMcpServer(server: UserVisibleMcpServer, query: string): boolean {
  const normalizedQuery = query.trim().toLocaleLowerCase()
  if (!normalizedQuery) {
    return true
  }

  return [server.displayName, server.name, server.description, server.url]
    .map((value) => normalizeServerLabel(value))
    .some((value) => value.includes(normalizedQuery))
}
